/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Percent_Fees_1Inputs */

const en_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% fees`)
};

const es_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de comisiones`)
};

const fr_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de frais`)
};

const de_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% Gebühren`)
};

const ja_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% の手数料にする`)
};

const zh_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 手续费`)
};

const ar_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% رسوم`)
};

const id_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% biaya`)
};

const it_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% di commissioni`)
};

const ru_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% комиссии`)
};

const pt_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de taxas`)
};

const ko_percent_fees_1 = /** @type {(inputs: Percent_Fees_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 수수료`)
};

/**
* | output |
* | --- |
* | "% fees" |
*
* @param {Percent_Fees_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const percent_fees_1 = /** @type {((inputs?: Percent_Fees_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Percent_Fees_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_percent_fees_1(inputs)
	if (locale === "es") return es_percent_fees_1(inputs)
	if (locale === "fr") return fr_percent_fees_1(inputs)
	if (locale === "de") return de_percent_fees_1(inputs)
	if (locale === "ja") return ja_percent_fees_1(inputs)
	if (locale === "zh") return zh_percent_fees_1(inputs)
	if (locale === "ar") return ar_percent_fees_1(inputs)
	if (locale === "id") return id_percent_fees_1(inputs)
	if (locale === "it") return it_percent_fees_1(inputs)
	if (locale === "ru") return ru_percent_fees_1(inputs)
	if (locale === "pt") return pt_percent_fees_1(inputs)
	return ko_percent_fees_1(inputs)
});